import React from "react";
import { View } from "react-native";

interface LottieProps {
  source: any;
  autoPlay?: boolean;
  loop?: boolean;
  resizeMode?: string;
  style?: any;
}

// Web-specific Lottie component that provides a safe fallback
const CrossPlatformLottie: React.FC<LottieProps> = ({
  source,
  autoPlay = true,
  loop = true,
  resizeMode = "contain",
  style
}) => {
  // For web, return a safe placeholder to avoid Platform.select errors
  return (
    <View 
      style={[
        {
          backgroundColor: 'transparent',
          justifyContent: 'center',
          alignItems: 'center',
        },
        style
      ]}
    >
      {/* Web fallback - animations disabled to prevent crashes */}
    </View>
  );
};

export default CrossPlatformLottie;